import { createSlice } from '@reduxjs/toolkit';
import { resetStore, resetStoreNoReload } from './loaderSlice';
export const normalizeReasonText = (text) => { var _a; return (_a = text === null || text === void 0 ? void 0 : text.toLowerCase()) === null || _a === void 0 ? void 0 : _a.trim().replace(/\.+$/, '').replace(/\s+/g, ' '); };
export const findReasonCatalogEntry = (reason, byOId, byLookupId, byText) => {
    if (reason.oId && (byOId === null || byOId === void 0 ? void 0 : byOId[reason.oId]))
        return byOId[reason.oId];
    if (reason.lookupId && (byLookupId === null || byLookupId === void 0 ? void 0 : byLookupId[reason.lookupId]))
        return byLookupId[reason.lookupId];
    const key = normalizeReasonText(reason.text);
    return key ? byText === null || byText === void 0 ? void 0 : byText[key] : undefined;
};
const initialState = {
    creditStatus: {},
    contractStatus: {},
    creditStatusByOId: {},
    contractStatusByOId: {},
    creditStatusByLookupId: {},
    contractStatusByLookupId: {},
    isLoaded: false,
};
export const reasonCatalogSlice = createSlice({
    name: 'reasonCatalog',
    initialState,
    reducers: {
        setReasonCatalog: (state, action) => {
            state.creditStatus = action.payload.creditStatus;
            state.contractStatus = action.payload.contractStatus;
            state.creditStatusByOId = action.payload.creditStatusByOId;
            state.contractStatusByOId = action.payload.contractStatusByOId;
            state.creditStatusByLookupId = action.payload.creditStatusByLookupId;
            state.contractStatusByLookupId = action.payload.contractStatusByLookupId;
            state.isLoaded = true;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetStore, () => initialState);
        builder.addCase(resetStoreNoReload, () => initialState);
    },
});
export const { setReasonCatalog } = reasonCatalogSlice.actions;
export default reasonCatalogSlice.reducer;
